import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('ErrorHandlerProvider');
export const ErrorHandlerProvider = Provider;
export const ErrorHandlerConsumer = Consumer;
export const ErrorHandlerContext = Context;
export const useErrorHandler = useContext;
//# sourceMappingURL=ErrorHandlerProvider.js.map